import { container, title } from "assets/jss/material-kit-react.js";
import imagesStyle from "assets/jss/material-kit-react/imagesStyles.js";

const claimCheckPageStyle = {
  container,
  ...imagesStyle,
  main: {
    background: "#FFFFFF",
    position: "relative",
    zIndex: "3",
  },
  profile: {
    textAlign: "center",
    "& img": {
      maxWidth: "160px",
      width: "100%",
      margin: "0 auto",
      transform: "translate3d(0, -50%, 0)",
    },
  },
  name: {
    marginTop: "-80px",
  },
  title: {
    ...title,
    display: "inline-block",
    position: "relative",
    marginTop: "30px",
    minHeight: "32px",
    textDecoration: "none",
  },
  description: {
    margin: "1.071rem auto 0",
    maxWidth: "600px",
    color: "#555",
    textAlign: "center !important",
  },
  typo: {},
  langToggle: {
    display: "inline-block",
    marginTop: 16,
    background: "#38c754",
    color: "#fff",
    border: "none",
    borderRadius: 4,
    padding: "6px 18px",
    cursor: "pointer",
    fontSize: "0.85rem",
    fontWeight: 600,
    "&:hover": {
      background: "#2e7d32",
    },
  },
  directiveSection: {
    padding: "32px",
    background: "#fff",
    borderBottom: "1px solid #e0e0e0",
  },
  directiveInner: {
    display: "flex",
    alignItems: "flex-start",
    gap: 20,
    maxWidth: 750,
    margin: "0 auto",
    "@media (max-width: 600px)": {
      flexDirection: "column",
    },
  },
  directiveIcon: {
    minWidth: 48,
    height: 48,
    background: "#1565c0",
    borderRadius: 8,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontSize: 24,
  },
  directiveTitle: {
    margin: "0 0 8px",
    fontSize: "1.2rem",
    color: "#1b5e20",
    fontWeight: 600,
  },
  directiveText: {
    margin: "0 0 12px",
    fontSize: "0.95rem",
    color: "#555",
    lineHeight: 1.6,
  },
  badges: {
    display: "flex",
    gap: 10,
    flexWrap: "wrap",
  },
  badge: {
    background: "#e8f5e9",
    color: "#2e7d32",
    padding: "4px 14px",
    borderRadius: 16,
    fontSize: "0.8rem",
    fontWeight: 500,
  },
  pdfSection: {
    padding: "20px 32px",
    background: "#f5f5f5",
    borderBottom: "1px solid #e0e0e0",
  },
  pdfList: {
    display: "flex",
    flexDirection: "column",
    gap: 16,
  },
  pdfInner: {
    maxWidth: 750,
    width: "100%",
    margin: "0 auto",
    display: "flex",
    alignItems: "center",
    gap: 16,
    "@media (max-width: 600px)": {
      flexDirection: "column",
      textAlign: "center",
    },
  },
  pdfIcon: {
    minWidth: 40,
    height: 48,
    background: "#c62828",
    borderRadius: 4,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    color: "#fff",
    fontSize: "0.75rem",
    fontWeight: 700,
  },
  pdfInfo: {
    flex: 1,
  },
  pdfTitle: {
    margin: "0 0 2px",
    fontSize: "0.95rem",
    fontWeight: 600,
    color: "#333",
  },
  pdfSubtitle: {
    margin: 0,
    fontSize: "0.8rem",
    color: "#777",
  },
  pdfButton: {
    background: "#1b5e20",
    color: "#fff",
    border: "none",
    padding: "8px 24px",
    borderRadius: 4,
    cursor: "pointer",
    fontSize: "0.85rem",
    fontWeight: 600,
    textDecoration: "none",
    "&:hover": {
      background: "#2e7d32",
    },
  },
  searchSection: {
    padding: "32px",
    background: "#fff",
    borderBottom: "1px solid #e0e0e0",
  },
  searchHeader: {
    maxWidth: 750,
    margin: "0 auto 24px",
    textAlign: "center",
  },
  searchTitle: {
    margin: "0 0 8px",
    fontSize: "1.3rem",
    color: "#1b5e20",
    fontWeight: 600,
  },
  searchSubtitle: {
    margin: "0 0 4px",
    fontSize: "0.9rem",
    color: "#777",
  },
  searchQrNote: {
    margin: "8px 0 0",
    fontSize: "0.75rem",
    color: "#aaa",
  },
  searchResults: {
    maxWidth: 950,
    margin: "0 auto",
  },
  table: {
    minWidth: 700,
  },
  tableHead: {
    textAlign: "center",
    fontWeight: "bold",
    marginTop: "20px",
    backgroundColor: "#82ee94",
    color: "white !important",
  },
  row: {
    "&:nth-of-type(odd)": {
      backgroundColor: "#fafafa",
    },
  },
  cell: {
    fontSize: "0.85rem",
  },
  cellHead: {
    fontSize: "0.85rem",
    textAlign: "center",
  },
  subTitle: {
    marginBottom: "10px",
  },
  subTitle2: {
    marginBottom: "40px",
  },
  ctaSection: {
    padding: "40px 32px",
    background: "linear-gradient(135deg, #1b5e20, #388e3c)",
    textAlign: "center",
    color: "#fff",
  },
  ctaTitle: {
    margin: "0 0 8px",
    fontSize: "1.3rem",
    fontWeight: 600,
  },
  ctaSubtitle: {
    margin: "0 0 20px",
    fontSize: "0.95rem",
    opacity: 0.85,
  },
  ctaButton: {
    background: "#fff",
    color: "#1b5e20",
    border: "none",
    padding: "12px 36px",
    borderRadius: 8,
    cursor: "pointer",
    fontSize: "0.95rem",
    fontWeight: 600,
    textDecoration: "none",
    "&:hover": {
      background: "#e8f5e9",
    },
  },
  footerInfo: {
    padding: "16px 32px",
    background: "#f5f5f5",
    textAlign: "center",
  },
  footerText: {
    margin: 0,
    fontSize: "0.75rem",
    color: "#999",
  },
};

export default claimCheckPageStyle;
